import React from 'react';

import { useEffect, useRef, useContext, useState } from 'react';

import { Formik } from 'formik';
import * as yup from 'yup';

import { Button, Form, Col, Row } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { toast } from 'react-toastify';
import AppContext from '../AppContext';
import Tooltip from '../helper/Tooltip';

import { salutation, firstName, lastName, phoneNo } from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

import Loader from '../helper/Loader';

const schema = yup.object().shape({
    salutation: salutation,
    firstname: firstName,
    lastname: lastName,
    phone: phoneNo,
});

const User = () => {
    const { Salutations } = useContext(AppContext);
    const { request } = useRequest();
    const [userRole, setUserRole] = useState(false);
    const [maxRadius, setMaxRadius] = useState(0);

    const formRef = useRef(null);
    const firstnameRef = useRef(null);
    const lastnameRef = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);
    const titleRef = useRef(null);
    const newsletterRef = useRef(null);
    const newsletterRadiusRef = useRef(null);
    const newsletterCycleRef = useRef(null);

    const getData = async () => {
        try {
            let result = await request("/User");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }
                return;
            }

            formRef.current.setFieldValue("salutation", json.user.SalutationID);
            formRef.current.setFieldValue("firstname", json.user.FirstName);
            formRef.current.setFieldValue("lastname", json.user.LastName);
            formRef.current.setFieldValue("phone", json.user.PhoneNo || "");
            formRef.current.setFieldValue("email", json.user.Email);
            formRef.current.setFieldValue("title", json.user.Title || "");
            formRef.current.setFieldValue("newsletterOptIn", json.user.NewsletterOptIn);
            formRef.current.setFieldValue("newsletterRadius", json.user.NewsletterRadius);
            formRef.current.setFieldValue("newsletterCycle", json.user.NewsletterCycle);

            setUserRole(json.user.Role);
            setMaxRadius(json.organisation.ContingentRadius);
        }
        catch (ex) {
            toast.error("Laden der Nutzerdaten fehlgeschlagen.");
        }
    };

    const updateData = async (values) => {
        let result = await request("/User/UpdateData", values);
        let json = result.data;
        if (json.r != 1) {
            if (json.message) {
                toast.error(json.message);
            }
            else {
                toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
            }
            return;
        }
        toast.success("Ihre Daten wurden erfolgreich geändert.");
    };

    useEffect(() => {
        getData();
    }, []);
    
    return (
        <Formik
            innerRef={(f) => (formRef.current = f)}
            validationSchema={schema}
            onSubmit={(values) => {
                updateData(values);
            }}
            initialValues={{
                salutation: 'Herr',
                title: '',
                firstname: '',
                lastname: '',
                phone: '',
                email: '',
                newsletterOptIn: false,
                newsletterRadius: 0,
                newsletterCycle: 0,
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => {

                if (!userRole) {
                    return <Loader />
                }
                return (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row>
                            <Col xs={12} md={6}>
                                <Form.Group as={Row} className="form-group" controlId="salutation">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label className="required">Anrede</Form.Label>
                                        <Tooltip name="anrede" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Select className="form-control" enabled="true" isInvalid={errors.salutation && touched.salutation} name="salutation" value={values.salutation} onBlur={handleBlur} onChange={handleChange}>
                                            {Salutations.map((option) => {
                                                return (
                                                    <option key={option.SalutationID} value={option.SalutationID}>
                                                        {option.Description}
                                                    </option>
                                                );
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.salutation}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group as={Row} className="form-group" controlId="title">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label sm={6}>Titel</Form.Label>
                                        <Tooltip name="titel" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control ref={titleRef} isInvalid={errors.title && touched.title} type="text" name="title" value={values.title} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.title}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6}>
                                <Form.Group as={Row} className="form-group" controlId="firstname">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label className="required" sm={6}>Vorname</Form.Label>
                                        <Tooltip name="vorname" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control ref={firstnameRef} isInvalid={errors.firstname && touched.firstname} type="text" name="firstname" value={values.firstname} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.firstname}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group as={Row} className="form-group" controlId="lastname">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label className="required" sm={6}>Nachname</Form.Label>
                                        <Tooltip name="nachname" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control ref={lastnameRef} isInvalid={errors.lastname && touched.lastname} type="text" name="lastname" value={values.lastname} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.lastname}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={6}>
                                <Form.Group as={Row} className="form-group" controlId="email">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label className="required" sm={6}>E-Mail-Adresse</Form.Label>
                                        <Tooltip name="email" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control readOnly ref={emailRef} isInvalid={errors.email && touched.email} type="text" name="email" value={values.email} onBlur={handleBlur} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Group as={Row} className="form-group" controlId="phone">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label sm={6}>Telefon</Form.Label>
                                        <Tooltip name="telefon" />
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Control ref={phoneRef} isInvalid={errors.phone && touched.phone} type="text" name="phone" value={values.phone} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.phone}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={12}>
                                <Form.Group className="form-group" controlId="newsletterOptIn">
                                    {values.newsletterOptIn == false && <Form.Check ref={newsletterRef} type="checkbox" name="newsletterOptIn" label=" Ich möchte über offene Termine und Aktionen per Mail informiert werden." value={values.newsletterOptIn} onChange={handleChange} isInvalid={errors.newsletterOptIn} />}
                                    {values.newsletterOptIn == true && <Form.Check ref={newsletterRef} type="checkbox" name="newsletterOptIn" label=" Ich möchte über offene Termine und Aktionen per Mail informiert werden." value={values.newsletterOptIn} onChange={handleChange} isInvalid={errors.newsletterOptIn} checked />}
                                    <div className="text-danger">{errors.newsletterOptIn && (errors.newsletterOptIn)}</div>
                                </Form.Group>
                            </Col>
                        </Row>

                        {userRole != "School" && <Row>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="form-group" controlId="newsletterRadius">
                                    <Col className="col-form-label" sm={6}>
                                        <Form.Label sm={6}>Umkreis für offene Termine</Form.Label>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Select className="form-control" ref={newsletterRadiusRef} isInvalid={errors.newsletterRadius && touched.newsletterRadius} name="newsletterRadius" onBlur={handleBlur} onChange={handleChange}>
                                            {maxRadius >= 75 && (values.newsletterRadius == 75 ? (<option value={75} selected>75 km</option>) : (<option value={75}>75 km</option>))}
                                            {maxRadius >= 150 && (values.newsletterRadius == 150 ? (<option value={150} selected>150 km</option>) : (<option value={150}>150 km</option>))}
                                            {maxRadius >= 999999999 && (values.newsletterRadius == 999999999 ? (<option value={999999999} selected>Unbegrenzt</option>) : (<option value={999999999}>Unbegrenzt</option>))}
                                            {(![75, 150, 999999999].includes(maxRadius) && maxRadius < 999999999) && (values.newsletterRadius == maxRadius ? (<option value={maxRadius} selected>{maxRadius} km</option>) : (<option value={maxRadius}>{maxRadius} km</option>))}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Form.Group as={Row} className="form-group" cnotrolId="newslettercycle">
                                    <Col className="col-form-label" mc={6}>
                                        <Form.Label sm={6}>Zyklus der Mails</Form.Label>
                                    </Col>
                                    <Col cm={6}>
                                        <Form.Select className="form-control" ref={newsletterCycleRef} isInvalid={errors.newsletterCycle && touched.newsletterCycle} name="newsletterCycle" onBlur={handleBlur} onChange={handleChange}>
{/*                                            {values.newsletterCycle == 1 ? (<option value={1} selected>Täglich</option>) : (<option value={1}>Täglich</option>)}*/}
                                            {values.newsletterCycle == 2 ? (<option value={2} selected>Wöchentlich</option>) : (<option value={2}>Wöchentlich</option>)}
                                            {values.newsletterCycle == 3 ? (<option value={3} selected>Monatlich</option>) : (<option value={3}>Monatlich</option>)}
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>

                        }
                        
                        <Row>
                            <Col>
                                <Button variant="secondary" type="submit">
                                    <i className="fa-solid fa-check mr-2"></i>Daten speichern
                                </Button>  
                            </Col>
                        </Row>

                        <MandatoryFieldNotice />
                    </Form>
                )
            }}
        </Formik>
    )
}

export default User;